<script setup lang="ts">
import type {Populated} from '~/types/populated'
import type {AboutUs} from '~/types/legacy'

const props = defineProps<{
  data: Populated<AboutUs>['stats']
}>()
</script>

<template>
  <Container class="screen-content relative grid grid-cols-2 items-center justify-center gap-8 py-8 md:flex">
    <div v-for="stat of data" :key="stat.title" class="relative text-center md:text-left">
      <Paragraph as="h2" size="small" class="!text-gray-500 md:!text-left">{{ stat.title }}</Paragraph>
      <Heading as="p" size="medium">{{ stat.data }}</Heading>
    </div>

    <div class="pointer-events-none absolute mx-auto h-full w-full max-w-xl">
      <div
        class="absolute bottom-0 left-0 h-full w-full origin-bottom scale-[3] bg-radial-gradient-main md:scale-100 md:scale-x-[1.75]"
      />
      <div class="absolute bottom-0 left-0 h-px w-full scale-x-150 bg-gradient-main md:scale-x-100" />
    </div>
  </Container>
</template>
